import { getChannel } from "../../../../../actions/Utilities/Channel";
import { useQuery } from "react-query";

export default function useChannel() {
  //Fetching Channel Details
  const {data, isFetching} = useQuery("GetChannels", getChannel, {
    refetchOnWindowFocus: false,
  });
  if(data){
    data.sort((a, b) => {
        let fa = a.channelName.toLowerCase(), fb = b.channelName.toLowerCase();
        return (fa < fb)?-1:(fa > fb?1:0);
    });
  }
  return {data, isFetching};
}
